// @flow @format
import ProgressBar from './ProgressBar';
export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.js